import { css as c, variants as a, modifier as e, styled as l } from "@lokalise/styled";
import { value as o, spacing as r } from "../../utils/theme/index.js";
import { Pressable as i } from "../Pressable/index.js";
const t = c`
	${a("$appearance", {
  primary: c`
			color: ${o("color.text.default")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${o("color.background.action.secondary.hover")};
				color: ${o("color.text.link.hover")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${o("color.background.action.secondary.hover")};
				color: ${o("color.text.link.hover")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${o("color.background.action.secondary.hover")};
				color: ${o("color.text.link.hover")};
			}

			// activated
			${e(
    "$active",
    c`
					background-color: ${o("color.background.active")};
					color: ${o("color.text.active")};
				`
  )}
		`,
  secondary: c`
			color: ${o("color.text.default")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${o("color.background.action.tertiary.hover")};
				color: ${o("color.text.default")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${o("color.background.action.tertiary.hover")};
				color: ${o("color.text.default")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${o("color.background.action.tertiary.hover")};
				color: ${o("color.text.default")};
			}

			// activated
			${e(
    "$active",
    c`
					background-color: ${o("color.background.active")};
					color: ${o("color.text.active")};
				`
  )}
		`,
  verified: c`
			color: ${o("color.text.default")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${o("color.background.warning")};
				color: ${o("color.text.default")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${o("color.border.warning")};
				color: ${o("color.text.default")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${o("color.background.warning")};
				color: ${o("color.text.default")};
			}

			// activated
			${e(
    "$active",
    c`
					background-color: ${o("color.background.warning")};
					color: ${o("color.text.default")};
				`
  )}
		`,
  reviewed: c`
			color: ${o("color.text.default")};

			// hover
			&:hover:not([disabled]) {
				background-color: ${o("color.background.success")};
				color: ${o("color.text.default")};
			}

			// pressed
			&:active:not([disabled]),
			&:focus:active:not([disabled]) {
				background-color: ${o("color.border.success")};
				color: ${o("color.text.default")};
			}

			// focus
			&:focus-visible:not([disabled]) {
				background-color: ${o("color.background.success")};
				color: ${o("color.text.default")};
			}

			// activated
			${e(
    "$active",
    c`
					background-color: ${o("color.background.success")};
					color: ${o("color.text.default")};
				`
  )}
		`
})}
`, d = c`
	${a("$size", {
  xs: c`
			height: ${o("size.height.iconbutton.extra-small")};
			padding: ${r(1)};
			font-size: calc(${o("size.height.iconbutton.extra-small")} - ${r(2)});
		`,
  sm: c`
			height: ${o("size.height.iconbutton.small")};
			padding: ${r(1)};
			font-size: calc(${o("size.height.iconbutton.small")} - ${r(2)});
		`,
  md: c`
			height: ${o("size.height.iconbutton.default")};
			padding: ${r(1)};
			font-size: calc(${o("size.height.iconbutton.default")} - ${r(2)});
		`,
  lg: c`
			height: ${o("size.height.iconbutton.large")};
			padding: ${r(1)};
			font-size: calc(${o("size.height.iconbutton.large")} - ${r(2)});
		`
})}
`, $ = l(i)`
	display: inline-flex;
	align-items: center;
	background-color: transparent;
	transition:
		background-color ${o("motion.speed.1")},
		color ${o("motion.speed.1")};
	border: 0;
	border-radius: ${o("radius.iconbutton")};
	text-decoration: none;

	${t}
	${d}

	// disabled
    &:disabled {
		cursor: not-allowed;
		color: ${o("color.text.disabled")};

		${e(
  "$isLoading",
  c`
				color: initial;
				cursor: auto;
				${t}
			`
)}
	}
`;
export {
  $ as Container
};
//# sourceMappingURL=styles.js.map
